import { useEffect, useState } from "react"
import { useScroll } from "framer-motion"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface useScrollProgressParameters {
  wrapperRef: any
  threshold: number
}

interface useScrollProgressReturnObject {
  scrollYProgress: number
}

const useScrollProgress: (
  useScrollProgressParameters
) => useScrollProgressReturnObject = ({ wrapperRef, threshold }) => {
  const [scrollYProgress, setScrollYProgress] = useState(null)
  const { scrollY } = useScroll()

  const scrollYChangeHandler = y => {
    if (!wrapperRef.current) return
    const wrapperEl = wrapperRef.current
    const top = window.scrollY + wrapperEl.getBoundingClientRect().top
    if (
      (y + window.innerHeight * (1 - threshold) > top &&
        y + window.innerHeight * (1 - threshold) <
          top + wrapperEl.clientHeight) ||
      scrollYProgress == null
    ) {
      setScrollYProgress(
        (y + window.innerHeight * (1 - threshold) - top) /
          wrapperEl.clientHeight
      )
    }
  }

  useEffect(() => scrollYChangeHandler(window.scrollY), [])
  useEffect(() => scrollY.onChange(scrollYChangeHandler), [scrollYProgress])

  return {
    scrollYProgress,
  }
}

export default useScrollProgress
